/*
 * Purpose: SSOT — every user-visible issue must ship with an actionable remedy
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { toast } from 'sonner';
import type { RemediationAction } from '@/components/errors/ContextualError';

/** Issue surfaces covered by the remediation rule (not only hard errors). */
export type IssueSurface =
  | 'inline_alert'
  | 'toast'
  | 'badge'
  | 'readiness_row'
  | 'disabled_control'
  | 'empty_state';

export const CONTEXTUAL_ISSUE_RULE =
  'Never present an issue (error, warning, blocked, needed, failed) without an actionable remedy on the same surface.';

export function runRemediationAction(action: RemediationAction): void {
  if (action.onClick) {
    action.onClick();
    return;
  }
  if (action.href) {
    window.location.assign(action.href);
  }
}

/** Toast helper — always pairs message with a primary fix action. */
export function toastContextualIssue(message: string, action: RemediationAction): void {
  toast.error(message, {
    action: {
      label: action.label,
      onClick: () => runRemediationAction(action),
    },
  });
}
